<page-loader *ngIf="!isLoaded"></page-loader>
<div id="page-push-edit" class="page-section series-form-page" *ngIf="isLoaded">
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous" (click)="onCancel()">
            <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a [routerLink]="['/app/scheduled-push-notification']">Scheduled Push Notifications</a>
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>

    <div class="page-section-content">
        <form novalidate [formGroup]="pushEditForm" (ngSubmit)="doSave()">
            <div class="form-wrapper-80">
                <h2>Content</h2>

                <div formArrayName="revisions">
                    <div class="revision-block"
                        *ngFor="let revision of revisionItems.controls; let revisionIndex = index"
                        [formGroupName]="revisionIndex">
                        <div class="revision-block__header">
                            <span class="revision-block__lang">{{ revision.value.languagePrefix }}</span>
                            <button type="button"
                                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20 delete-btn"
                                *ngIf="revisionItems.length > 1"
                                (click)="removeRevision(revisionIndex)" title="Remove">
                                <svg-icon icon="trash" class="w-100 h-100"></svg-icon>
                            </button>
                        </div>

                        <div class="app-c-form-group">
                            <label class="app-c-form--label">Title</label>
                            <input class="app-c-form-control" type="text" formControlName="title" />
                            <div class="error-message"
                                *ngIf="getRevisionFormGroup(revisionIndex).controls['title'].touched && getRevisionFormGroup(revisionIndex).controls['title'].errors?.required">
                                The push notification needs a title.
                            </div>
                        </div>

                        <div class="app-c-form-group">
                            <label class="app-c-form--label">Body</label>
                            <textarea class="app-c-form-control" rows="3" formControlName="body"></textarea>
                            <div class="error-message"
                                *ngIf="getRevisionFormGroup(revisionIndex).controls['body'].touched && getRevisionFormGroup(revisionIndex).controls['body'].errors?.required">
                                The push notification needs a description.
                            </div>
                        </div>

                        <div class="app-c-form-group">
                            <label class="app-c-form--label">URL</label>
                            <input class="app-c-form-control" type="text" formControlName="url"
                                placeholder="https://..." />
                            <p class="form-help-text">URL must be complete (include http:// or https://).</p>
                        </div>
                    </div>
                </div>

                <div class="add-language-row">
                    <ng-container *ngFor="let language of languages">
                        <button type="button" class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                            *ngIf="!language.active" (click)="addRevision(language.prefix)">
                            Add {{ language.full }}
                        </button>
                    </ng-container>
                </div>

                <h2>Audience</h2>

                <div class="app-c-form-group" *ngIf="user.userType === 'superadmin'">
                    <label class="app-c-form--label" for="pushType">Type of push</label>
                    <select #pushTypeSelect class="app-c-form-control" id="pushType" formControlName="type">
                        <option *ngFor="let pushType of pushTypes" [value]="pushType.type">{{ pushType.name }}</option>
                    </select>
                    <div class="error-message" *ngIf="f.type.touched && f.type.errors?.required">
                        The push notification needs a type.
                    </div>
                </div>

                <div class="app-c-form-group"
                    *ngIf="user.userType === 'superadmin' && pushTypeSelect.value === 'organization' && enableMultiOrg">
                    <label class="app-c-form--label">Organizations</label>
                    <multiselect-autocomplete
                        formControlName="orgIds"
                        placeholder="Select an organization"
                        [items]="multiSelOrgs"
                        [formValue]="pushEditForm.value.orgIds"
                        (onSelectItems)="onSelectOrgs($event)">
                    </multiselect-autocomplete>
                </div>

                <div class="app-c-form-group"
                    *ngIf="isInternal && user.userType !== 'superadmin' && organizations.length > 0">
                    <label class="app-c-form--label">Organizations</label>
                    <multiselect-autocomplete
                        formControlName="orgIds"
                        placeholder="Select an organization"
                        [items]="multiSelOrgs"
                        [formValue]="pushEditForm.value.orgIds"
                        (onSelectItems)="onSelectOrgs($event)">
                    </multiselect-autocomplete>
                </div>

                <p class="form-help-text"
                    *ngIf="isInternal && user.userType !== 'superadmin' && organizations.length === 0">
                    You have no associated organizations at the moment and will not be able to schedule push notifications.
                </p>

                <div class="app-c-form-group" *ngIf="user.userType === 'orgadmin'">
                    <label class="app-c-form--label">Organizations</label>
                    <select class="app-c-form-control" formControlName="orgIds" multiple>
                        <option *ngFor="let organization of organizations" [value]="organization.id">
                            {{ organization.name }}
                        </option>
                    </select>
                </div>

                <h2>Schedule</h2>

                <div class="app-c-form-group">
                    <label class="app-c-form--label" for="scheduledDate">Scheduled Date</label>
                    <input class="app-c-form-control" type="datetime-local" id="scheduledDate"
                        formControlName="scheduledDate" />
                </div>

                <div class="check-box-container">
                    <input type="checkbox" id="recurring" formControlName="recurring" />
                    <label for="recurring">Recurring?</label>
                </div>

                <div *ngIf="pushEditForm.value.recurring">
                    <div class="app-c-form-group">
                        <label class="app-c-form--label" for="recurringDay">Scheduled Day</label>
                        <select class="app-c-form-control" id="recurringDay" formControlName="day">
                            <option value="">Select a day</option>
                            <option *ngFor="let day of days_of_week" [value]="day">{{ day }}</option>
                        </select>
                        <div class="error-message" *ngIf="f.day.touched && f.day.errors?.required">
                            The recurring push notification needs a day.
                        </div>
                    </div>

                    <div class="app-c-form-group">
                        <label class="app-c-form--label" for="recurringTime">Scheduled Time</label>
                        <input class="app-c-form-control" type="time" id="recurringTime"
                            formControlName="time" />
                        <div class="error-message" *ngIf="f.time.touched && f.time.errors?.required">
                            The recurring push notification needs a time.
                        </div>
                    </div>
                </div>

                <div class="form-actions">
                    <button type="button" class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                        (click)="onCancel()">Cancel</button>
                    <button type="submit" class="app-c-btn app-c-btn--primary app-c-btn--curve">Save</button>
                </div>
            </div>
        </form>
    </div>
</div>
